import { render } from "./LifeInsuranceApplications.vue?vue&type=template&id=194b075e&scoped=true"
import script from "./LifeInsuranceApplications.vue?vue&type=script&lang=js"
export * from "./LifeInsuranceApplications.vue?vue&type=script&lang=js"

import "./LifeInsuranceApplications.vue?vue&type=style&index=0&id=194b075e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194b075e"]])

export default __exports__